<template>
  <div class="service detail wrap">
    <div class="text-bg isign">
      <div class="text-wrap">
        <p>{{ $t('solution.detail.isign.lineText.01') }}</p>
        <p>{{ $t('solution.detail.isign.lineText.02') }}</p>
        <p>{{ $t('solution.detail.isign.lineText.03') }}</p>
      </div>
    </div>

    <!-- 타이틀 섹션 -->
    <HalfPageLayout class="isign title">
      <template #half-left>
        <div class="img isign"></div>
      </template>
      <template #half-right>
        <div class="inner-contents">
          <div class="contents-title">
            <SsoTabs current="isign" />
            <h3 style="line-height: 1.1">
              {{ $t('solution.title.isign') }}
            </h3>
            <h6>Password-less Authentication / Penta Security</h6>
            <h4>{{ $t('solution.detail.isign.subTitle') }}</h4>
          </div>
          <h5>{{ $t('solution.detail.isign.desc') }}</h5>
        </div>
      </template>
    </HalfPageLayout>

    <!-- 사용자·관리자 편의성 -->
    <HalfPageLayout class="isign summary">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('solution.detail.isign.firstPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:fingerprint-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.firstPage.contents.01.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.firstPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:key-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.firstPage.contents.02.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.firstPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:sliders-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.firstPage.contents.03.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.firstPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-01"></div>
      </template>
    </HalfPageLayout>

    <!-- 강력한 보안 및 컴플라이언스 -->
    <HalfPageLayout class="isign summary bg-light">
      <template #half-left>
        <div class="img visual-02"></div>
      </template>
      <template #half-right>
        <div class="animation-bg">
          <div class="gear"><SvgGear /></div>
          <div class="gear"><SvgGear /></div>
        </div>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('solution.detail.isign.secondPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:shield-warning-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.secondPage.contents.01.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.secondPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:seal-check-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.secondPage.contents.02.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.secondPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:check-square-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.secondPage.contents.03.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.secondPage.contents.03.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </HalfPageLayout>

    <!-- 시스템 구성 및 운영 자동화 -->
    <HalfPageLayout class="isign summary">
      <template #half-left>
        <div class="inner-contents">
          <div class="section-title" data-aos="fade">
            <h3 class="hl">{{ $t('solution.detail.isign.thirdPage.title') }}</h3>
          </div>
          <div class="section-contents">
            <div class="contents-list icon" data-aos="fade" data-aos-delay="500">
              <Icon icon="ph:device-mobile-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.thirdPage.contents.01.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.thirdPage.contents.01.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1000">
              <Icon icon="ph:arrows-merge-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.thirdPage.contents.02.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.thirdPage.contents.02.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="1500">
              <Icon icon="ph:robot-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.thirdPage.contents.03.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.thirdPage.contents.03.desc') }}</dd>
              </dl>
            </div>
            <div class="contents-list icon" data-aos="fade" data-aos-delay="2000">
              <Icon icon="ph:headset-thin" />
              <dl>
                <dt>{{ $t('solution.detail.isign.thirdPage.contents.04.title') }}</dt>
                <dd>{{ $t('solution.detail.isign.thirdPage.contents.04.desc') }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #half-right>
        <div class="img visual-03"></div>
      </template>
    </HalfPageLayout>

    <!-- 인증 흐름 4단계 -->
    <section class="section isign auth-flow bg-light">
      <div class="inner-contents">
        <div class="section-title" data-aos="fade">
          <h3 class="hl">{{ $t('solution.detail.isign.authFlow.title') }}</h3>
        </div>
        <div class="flow-steps" data-aos="fade" data-aos-delay="500">
          <div class="flow-step">
            <div class="step-number">01</div>
            <Icon icon="ph:cursor-click-thin" />
            <dl>
              <dt>{{ $t('solution.detail.isign.authFlow.steps.01.title') }}</dt>
              <dd>{{ $t('solution.detail.isign.authFlow.steps.01.desc') }}</dd>
            </dl>
          </div>
          <div class="flow-arrow"><Icon icon="ph:arrow-right-thin" /></div>
          <div class="flow-step">
            <div class="step-number">02</div>
            <Icon icon="ph:bell-thin" />
            <dl>
              <dt>{{ $t('solution.detail.isign.authFlow.steps.02.title') }}</dt>
              <dd>{{ $t('solution.detail.isign.authFlow.steps.02.desc') }}</dd>
            </dl>
          </div>
          <div class="flow-arrow"><Icon icon="ph:arrow-right-thin" /></div>
          <div class="flow-step">
            <div class="step-number">03</div>
            <Icon icon="ph:fingerprint-thin" />
            <dl>
              <dt>{{ $t('solution.detail.isign.authFlow.steps.03.title') }}</dt>
              <dd>{{ $t('solution.detail.isign.authFlow.steps.03.desc') }}</dd>
            </dl>
          </div>
          <div class="flow-arrow"><Icon icon="ph:arrow-right-thin" /></div>
          <div class="flow-step">
            <div class="step-number">04</div>
            <Icon icon="ph:check-circle-thin" />
            <dl>
              <dt>{{ $t('solution.detail.isign.authFlow.steps.04.title') }}</dt>
              <dd>{{ $t('solution.detail.isign.authFlow.steps.04.desc') }}</dd>
            </dl>
          </div>
        </div>
      </div>
    </section>

    <!-- 도입 기대 효과 -->
    <section class="section isign benefit">
      <h2 class="hl section-title">
        {{ $t('solution.detail.isign.benefit.title') }}
      </h2>
      <div class="section-contents">
        <div class="inner-contents">
          <div class="contents-list">
            <dl data-aos="zoom-in">
              <div class="img isign"></div>
              <dt>{{ $t('solution.detail.isign.benefit.contents.01.title') }}</dt>
              <dd>{{ $t('solution.detail.isign.benefit.contents.01.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img isign"></div>
              <dt>{{ $t('solution.detail.isign.benefit.contents.02.title') }}</dt>
              <dd>{{ $t('solution.detail.isign.benefit.contents.02.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img isign"></div>
              <dt>{{ $t('solution.detail.isign.benefit.contents.03.title') }}</dt>
              <dd>{{ $t('solution.detail.isign.benefit.contents.03.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img isign"></div>
              <dt>{{ $t('solution.detail.isign.benefit.contents.04.title') }}</dt>
              <dd>{{ $t('solution.detail.isign.benefit.contents.04.desc') }}</dd>
            </dl>
            <dl data-aos="zoom-in">
              <div class="img isign"></div>
              <dt>{{ $t('solution.detail.isign.benefit.contents.05.title') }}</dt>
              <dd>{{ $t('solution.detail.isign.benefit.contents.05.desc') }}</dd>
            </dl>
          </div>
        </div>
        <router-link to="/contact" class="button big line">
          {{ $t('service.detail.contact') }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import HalfPageLayout from '@/components/HalfPageLayout'
import { Icon } from '@iconify/vue'
import SvgGear from '@/components/SvgGear'
import SsoTabs from '@/components/SsoTabs'

export default {
  name: 'SolutionDetailISIGN',
  components: { SvgGear, HalfPageLayout, Icon, SsoTabs }
}
</script>

<style scoped>
</style>
